import { useEffect, useMemo, useRef, useState } from 'react';
var useGetGridHeight = function () {
    var _a = useState(window.innerHeight), windowHeight = _a[0], setWindowHeight = _a[1];
    var _b = useState(0), topDistance = _b[0], setTopDistance = _b[1];
    var _c = useState(0), bottomDistance = _c[0], setBottomDistance = _c[1];
    var gridRef = useRef(null);
    var paginationRef = useRef(null);
    useEffect(function () {
        var handleResize = function () {
            var _a, _b;
            setTopDistance(((_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop) || 0);
            setBottomDistance(((_b = paginationRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0);
            setWindowHeight(window.innerHeight);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    var gridHeight = useMemo(function () {
        var calculatedHeight = windowHeight - topDistance - bottomDistance;
        if (calculatedHeight !== windowHeight && calculatedHeight > 360) {
            return calculatedHeight - 25;
        }
        else {
            // grids inside modals
            return undefined;
        }
    }, [bottomDistance, topDistance, windowHeight]);
    return { gridHeight: gridHeight, gridRef: gridRef, paginationRef: paginationRef };
};
export default useGetGridHeight;
